/**
 * Remove ids that are part of a removed subtree.
 */
export function withoutRemovedNodeIds(
  ids: readonly string[],
  removedNodeIds: ReadonlySet<string>,
): string[] {
  return ids.filter(id => !removedNodeIds.has(id));
}
